<template>
    <the-header-menu />
    <el-container class="reusable-page">

      <div class="lnd-cover">
        <h1 class="lnd-headline">Motorový výcvik &#8211; ULL</h1>
      </div>

      <div class="main-content">
        <el-page-header content="Výcvik - ULL" @back="goBack" title="Zpět" /> 
        <div class="content">
          <h3>Výcvik pilota ultralehkých sportovních letadel –⁠ ULL</h3>

          <span>
              Nechcete být ve vzduchu závislí pouze na nevyzpytatelném termickém proudění a raději byste pilotoval letoun s motorem? Potom z naší nabídky zvolte výcvik pilota ultralehkých letounů. Létání v této kategorii je ideální volbou pro volnočasový koníček, vzhledem k výrazně nižší ceně za letovou hodinu oproti „dospělým letadlům.“
              Jako držitel pilotního oprávnění této kategorie získáte možnost létat po celé České republice, na Slovensku a při splnění dalších i v jiných zemích Evropské unie. Posádka ULL však může čítat pouze pilota a jednoho cestujího.<br>
              Pokud se rozhodnete absolvovat letecký výcvik s námi, můžete si být jistí velmi osobním přístupem od instruktorů, kteří jsou ve vzduchu jako doma.
              S lehkostí vám předají své znalosti a Vy si tak pod jejich vedením osvojíte základní letecké dovednosti. Celý výcvik je poté zakončený pilotní zkouškou, která se skládá z praktické a teoretické části.

          </span>
          <!-- <div style="padding-top: 40px">
          <table>
            <tr>
              <th>Typ letounu</th>
              <th>Cena za l.h. výcviku</th>
            </tr>
            <tr>
              <td>Alto 912 TG - ULL</td>
              <td>XXXXX,-</td>
            </tr>
          </table>
            Všechny ceny jsou uvedené s DPH a sazbou instruktora<br>
          </div> -->

          <div class="vl-images-w">
            <el-carousel :interval="4000" type="card" height="200px" >
                <el-carousel-item v-for="i in photos_url" :key="i" @click="toggle()">
                    <!-- <el-image :src="i" :lazy="true"></el-image> -->
                    <img :src="i" loading="lazy" style="max-height:100%;">
                </el-carousel-item>
            </el-carousel>
          </div>

          <el-image-viewer v-if="viewer_toggled" :url-list="photos_url" @close='toggle()' :hide-on-click-modal='true' />
        </div>
      </div>
      <the-footer />
    </el-container>
</template>

<script>

import TheHeaderMenu from '../components/TheHeaderMenu3.vue'
import TheFooter from '../components/TheFooter.vue'

import { useRouter } from 'vue-router'
import { ref } from '@vue/reactivity'


export default {
    name: "PageUllVycvik",
    components: {
      TheHeaderMenu,
      TheFooter
    },
    setup(){
      const router = useRouter();

      const viewer_toggled = ref(false)
      const toggle = function(){
        viewer_toggled.value = !viewer_toggled.value;
      }      
      let photos_url = [];
      for(let img_n of [12, 25, 2, 4]){ //[12, 25, 2, 4]
        photos_url.push(require("../../src/assets/photos/img"+String(img_n)+".jpg"))
      }

      function goBack(){
        router.back()
      }

      return {goBack, photos_url, viewer_toggled, toggle}
    }

}
</script>


<style scoped>


.vl-images-w{
    width:100%;
    padding-top: 50px;
}

.vl-images{
    
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
}
.vl-img{
    height: 200px;
    padding-top: 10px;
}


.main-content{
  width: 90%;
  padding-top: 20px;
  padding-bottom: 30px;
}
.content{
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 30px;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
}
.lnd-cover{
  width: 100%;
  height: 300px;
  background-image: url("../../src/assets/cover/img16.jpg");
  background-repeat: no-repeat;
  /* background-attachment: fixed; */
  background-position: right top;
  background-size: cover;
}
.lnd-headline{
  text-align: center;
  position: relative;
  top: 40%;
}
.reusable-page{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  height: 100%;
  width: 100%;
}

</style>